import { Injectable } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import * as moment from 'moment';

import { HttpClient } from '@angular/common/http';
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { transform, forEach } from "lodash";

function _window(): any {
    // return the global native browser window object
    return window;
}

class AppConfigSite {
    public readonly classCssCheckprice = "checkprice-index";
    public readonly classCssRecap = "checkprice-recpa";
    constructor(conf: any) {
        this.oldlogin = conf.oldlogin;
        this.start = new Date(conf.start.toString().concat(' 00:00:00'));
        this.end = new Date(conf.end.toString().concat(' 00:00:00'));
        this.Ccurrency = conf.Ccurrency;
        this.Cpercente = conf.Cpercente;
        this.defaultlangue = conf.defaultlangue;
        this.promo = conf.promo;
        this.idEtab = conf.idEtab;
        this.hosteimage = conf.hosteimage;
        this.hosteimageimg = conf.hosteimageimg;
        this.host = conf.host;
        this.apihost = conf.apihost;
        this.adults = conf.adults;
        this.enfants = conf.enfants == undefined ? 0 : conf.enfants;
        this.country = conf.country == undefined ? '' : conf.country;
        this.device = conf.device == undefined ? '' : conf.device;
        this.agesEnfants = conf.agesEnfants == undefined ? [] : conf.agesEnfants;
        this.oldVersion = conf.oldVersion;
        this.isMobile = conf.isMobile;
        this.toManager = conf.toManager;
        this.bookdirect = conf.bookdirect != undefined ? conf.bookdirect : true;
        this.idCentral = isNaN(parseInt(conf.idcentral)) ? 0 : parseInt(conf.idcentral);
        this.stripeApiKeyPublic = conf.stripeApiKeyPublic != undefined ? conf.stripeApiKeyPublic : '';
        this.hubUrl = conf.hubUrl;
        this.tokenHub = conf.tokenHub;
        this.userTokenHub = conf.userTokenHub;
        this.utm_source = conf.utm_source;
        this.hi = conf.hi == undefined ? false : conf.hi;
        this.urlQuery = conf.urlQuery == undefined ? {} : conf.urlQuery;
        let newAgesEnfants = [];
        for (let i = 0, max = this.enfants; i < max; i++) {
            newAgesEnfants[i] = 0;
            if (!!this.agesEnfants[i]) {
                newAgesEnfants[i] = this.agesEnfants[i];
            }
        }
        this.agesEnfants = newAgesEnfants;
    }

    oldlogin: string;
    start: Date;
    end: Date;
    Ccurrency: string;
    Cpercente: number;
    defaultlangue: string;
    promo: boolean;
    idEtab: number;
    hosteimage: string;
    hosteimageimg: string;
    host: string;
    apihost: string;
    adults: number;
    enfants: number;
    agesEnfants: Array<number>;
    country: string;
    device: string;
    oldVersion: boolean;
    isMobile: boolean;
    toManager: boolean;
    bookdirect: boolean;
    idCentral: number;//deprecated
    stripeApiKeyPublic: string;
    hubUrl: string;
    tokenHub: string;
    userTokenHub: string;
    utm_source: string;
    hi: boolean;
    urlQuery: object;

    isGolleHotelFinder(): boolean {
        return true;
        // return this.utm_source == 'ghf';
    }
}

@Injectable({
    providedIn: 'root'
})
export class WindowRefService {
    readonly _HB: string = "hotelbeds";
    readonly _NameCentral: string = "mybeds.travel";
    private _appConfig: AppConfigSite;
    constructor(private http: HttpClient) {
        this._appConfig = new AppConfigSite(_window().appConfig);
    }
    get nativeWindow(): Window {
        return _window();
    }
    get appConfigSite(): AppConfigSite {
        return this._appConfig;
    }

    /**
     *  generatel new url and pushed to url navigator
     */
    generateNewUrlAndChanged(start: string, end: string, adults: number, enfants: number, agesEnfants: Array<number>): { Page: string, Url: string } {
        let newUrl = '', searchParams = new URLSearchParams(this.nativeWindow.location.search), paramsUrl = {};
        let lang = this.appConfigSite.defaultlangue
        let devise = this.appConfigSite.Ccurrency
        for (const [key, value] of searchParams.entries()) {
            paramsUrl[key] = value
        }
        forEach(this.appConfigSite.urlQuery, (value, key) => {
            paramsUrl[key] = value
        });
        paramsUrl['start_date'] = start;
        paramsUrl['end_date'] = end;
        paramsUrl['start'] = start;
        paramsUrl['end'] = end;
        paramsUrl['adults'] = adults;
        paramsUrl['enfants'] = enfants;
        paramsUrl['lang'] = lang; //lang for test ;)
        paramsUrl['devise'] = devise;
        if(enfants > 0 && agesEnfants && agesEnfants.length > 0) {
            agesEnfants.forEach((age, idx) => {
                paramsUrl[`agesEnfants[${idx}]`] = age;
            });
        }
        newUrl = Object.keys(paramsUrl).map(key => `${key}=${encodeURIComponent(paramsUrl[key])}`).join('&');
        let url = ''.concat(this.nativeWindow.location.origin, this.nativeWindow.location.pathname.toString().replace(/\/[a-z]{2}\//, `/${lang}/`), '?', newUrl, this.nativeWindow.location.hash);
        let obj = { Page: document.title, Url: url };
        if (typeof (history.pushState) != "undefined") {
            history.pushState(obj, obj.Page, obj.Url);
        }
        return obj
    }

    /**
    * generate Url Image
    * @returns string
    */
    generateUrlImage(image, size = "300X199"): string {
        return this._appConfig.hosteimageimg.concat("images/", this._appConfig.idEtab.toString(), "/upload/", size.toString(), "/", image);
    }

    /**
    * generate Boolean (true if app in mode dev)
    * @returns Boolean
    */
    static isModeDev(): Boolean {
        let result = window.location.href.includes('app_dev.php') || window.location.host.includes('localhost');
        return result;
    }

    /**
     * mappedLang
     */
    public mappedLang(value: string): string {
        let valueMapping: string = value;
        if (value == 'tl') {
            valueMapping = 'fil';
        } else if (value == 'no') {
            valueMapping = 'nn';
        }
        if ('zh' == value) {
            moment.locale('zh-CN');
        } else if ('tl' == value) {
            moment.locale('tl-ph');
        } else {
            moment.locale(value);
        }
        return valueMapping;
    }

    /**
    * nbr nights
    * @returns number
    */
    public nbrNights() {
        let dateStart = moment(this._appConfig.start);
        let dateEnd = moment(this._appConfig.end);
        return dateEnd.diff(dateStart, 'days');
    }

    /**
    * get a specific translation
    * @returns translation object
    */
    public getTranslation(lang: string): Observable<any> {
        //        let domains = [
        //            this.idEtab,
        //            this.idEtab + "_Chamber",
        //            this.idEtab + "_OfferExclusive",
        //            this.idEtab + "_LigneTarifaire",
        //            this.idEtab + "_ConditionReservation",
        //            this.idEtab + "_OfferExclusive",
        //            this.idEtab + "_LigneTarifierCategorie",
        //            "_ChamberCaracteristique",
        //            this.idEtab + "_Service",
        //            this.idEtab + "_ToKnow",
        //            this.idEtab + "_GoodToKnowType",
        //            this.idEtab + "_GoodToKnow",
        //            this.idEtab + "_PopulairFacilities",
        //        ].join(',')
        let path = this.appConfigSite.host + 'site/translations?locales=' + lang + '&id=' + this.appConfigSite.idEtab /*+ '&domains=' + domains*/;
        return this.http.get(path).pipe(catchError(res => {
            return of({});
        })).pipe(map(response => {
            let lowerObj = transform(response['translations'][lang], (result, val, key) => { result[key.toLowerCase()] = val; });
            return lowerObj;
        }));
    }

    /**
     * load langue for curreny & date
     */
    localeInitializer(localeId: string, localIdOrg: string = localeId): Promise<any> {
        return import(
            `@angular/common/locales/${localeId}.js`
        ).then(module => {
            module.default[0] = localIdOrg;
            registerLocaleData(module.default);
        });
    }
}
